import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { CheckCircle, ArrowRight, Building2, Crown } from "lucide-react";
import { useAuth } from '../contexts/AuthContext';

const ExhibitorBriefSuccess = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useAuth();
  
  const briefId = location.state?.briefId || 'brf_12345';

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <Card className="max-w-2xl w-full">
        <CardHeader className="text-center pb-4">
          <div className="mx-auto w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mb-4">
            <CheckCircle className="w-8 h-8 text-green-600" />
          </div>
          <CardTitle className="text-2xl text-gray-900">Brief Başarıyla Gönderildi!</CardTitle>
        </CardHeader>
        
        <CardContent className="text-center space-y-6">
          <p className="text-lg text-gray-600">
            Brief ID: <span className="font-semibold">{briefId}</span>
          </p>
          
          <div className="bg-blue-50 p-4 rounded-lg">
            <p className="text-blue-800 font-medium mb-2">
              Teklifler için firmalara yönlendirildi
            </p>
            <p className="text-blue-700 text-sm">
              Qualified contractors size 24-48 saat içinde ulaşacak ve tekliflerini sunacak.
            </p>
          </div>

          {/* Gold Features Notice */}
          <div className="bg-yellow-50 border border-yellow-200 p-4 rounded-lg">
            <div className="flex items-start">
              <Crown className="w-6 h-6 text-yellow-600 mr-3 mt-0.5" />
              <div className="text-left">
                <h4 className="font-semibold text-yellow-800 mb-2">Gold olmayan kullanıcılar için:</h4>
                <p className="text-yellow-700 text-sm mb-2">
                  Firma dizini ve doğrudan iletişim özellikleri Gold paket ile açılır.
                </p>
                <Button 
                  size="sm" 
                  className="bg-yellow-600 hover:bg-yellow-700"
                  onClick={() => navigate('/#/exhibitor/landing#pricing')}
                >
                  <Crown className="w-4 h-4 mr-2" />
                  Gold Pakete Geç
                </Button>
              </div>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button 
              variant="outline"
              onClick={() => navigate('/#/')}
            >
              Ana Sayfaya Dön
            </Button>
            
            <Button 
              onClick={() => navigate('/#/exhibitor/landing')}
              className="bg-blue-600 hover:bg-blue-700"
            >
              <Building2 className="w-4 h-4 mr-2" />
              Yeni Brief Oluştur
              <ArrowRight className="w-4 h-4 ml-2" />
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default ExhibitorBriefSuccess;